// Единый источник базового URL бэкенда для фронтенда.
// REACT_APP_API_URL задаётся в production (Render) как СХЕМА+ХОСТ, без /api и без
// завершающего слэша, напр. https://artgallery-jous.onrender.com.
// Локально (переменная не задана) бэкенд ожидается на :3001.
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

// Хост бэкенда — для legacy-src изображений: `${apiUrl}/${imageValue}`.
export const apiUrl = API_URL;

// baseURL для axiosApi (все API-запросы идут под /api).
export const apiBaseUrl = `${API_URL}/api`;
